module.exports = __webpack_public_path__ + "static/media/college_5.4ebb89cd.jpg";